<template>

                      <div >
             <v-progress-linear
             :active='loader'
            color="blue accent-4"
            indeterminate
            rounded
            height="10"
          ></v-progress-linear>
          <div v-if='!loader'>
                        <blockquote class="blockquote"><span class='headline font-weight-bold'>Summary</span><br>
                          <ol>
                            <li class='ma-2 '>Your results identified a pathogenic variant in the <span class='font-italic'>{{variant.gene}}</span> gene.</li>
                            <li class='ma-2'><span class='font-italic'>{{variant.gene}}</span> pathogenic variants are associated with an increased risk to develop certain types of cancer including breast, ovarian prostate and pancreatic.</li>
                            <li class='ma-2 '>This result may influence healthcare recommendations and treatment options. </li>
                            <li class='ma-2 '>Information about your test results may be important for your relatives and have implications for their healthcare.</li>
                            <li class='ma-2 '>There were no other pathogenic or likely pathogenic variants seen in any of the other genes that were analyzed.</li>
                          </ol>
                        </blockquote>

                        <v-alert
                          color="cyan"
                          border="left"
                          elevation="2"
                          colored-border
                          icon="mdi-lightbulb"
                        >
                          A summary of the pathogenic, likely pathogenic and variants of unknown significance are included below.
                        </v-alert>

                        <v-alert
                          color="cyan"
                          border="left"
                          elevation="2"
                          colored-border
                          icon="mdi-calendar"
                        >
                          According to the records that you provided, you underwent genetic testing through <span class='font-weight-black'>{{variant.labName}}</span> on <span class='font-weight-black'>{{variant.reportData}}.</span>
                        </v-alert>

                        <v-alert
                          color="cyan"
                          border="left"
                          elevation="2"
                          colored-border
                          icon="mdi-test-tube"
                        >
                          This testing analyzed the following genes for variants: <span class='font-weight-black font-italic'>BRCA1</span> and <span class='font-weight-black'><span class='font-italic'>BRCA2</span>.</span>
                        </v-alert>
                        <blockquote class="blockquote"><span class='headline font-weight-bold'>Pathogenic Variant Identified:</span>
                        </blockquote>

                        <v-alert
                            v-if='variant.testResult === "Positive"'
                          color="red"
                          border="left"
                          elevation="5"
                          colored-border
                          prominent
                          icon="mdi-plus"
                        >

                          <p>Result : {{variant.testResult}}</p>
                          <p>Gene Name: <span class='font-italic'>{{variant.gene}}</span></p>
                          <p>Variant Name: {{variant.geneName}}</p>
                          <p>Variant Classification: {{variant.classification}}</p>
                          <p>Variant ID: {{variant.variantId}}</p>
                        </v-alert>

                       <v-alert
                            v-else
                          color="green"
                          border="left"
                          elevation="5"
                          colored-border
                          prominent
                          icon="mdi-minus"
                        >
                         <p>Result : {{variant.testResult}}</p>
                          <p>Gene Name: <span class='font-italic'>{{variant.gene}}</span></p>
                          <p>Variant Name: {{variant.geneName}}</p>
                          <p>Variant Classification: {{variant.classification}}</p>
                          <p>Variant ID: {{variant.variantId}}</p>
                       </v-alert>



                        <blockquote class="subheading blockquote"><span class='headline font-weight-bold'>The <span class='font-italic'>{{testResultContent[0].GeneName}}</span> Gene</span><br><span>Last updated {{testResultContent[0].LastUpdate}}</span><br>
                        </blockquote>

                        <component
                          v-for="(field, index) in testResultContent[0].schema"
                          :key="index"
                          :is="field.fieldType"
                          v-bind="field"
                        >
                        </component>

                        <blockquote class='blockquote'>
                          <span class='headline font-weight-bold'>Recommendations for Cancer Treatment</span><br>
                        </blockquote>
                        <blockquote class='blockquote'>
                          <a
                            href='https://www.nccn.org/'
                            target='_blank'
                          >The National Comprehensive Cancer Network</a>® (NCCN®) is a not-for-profit alliance of 28 leading cancer centers devoted to patient care, research, and education. Each year the NCCN reviews the medical literature and updates recommendations for the best care for people with <span class='font-italic'>BRCA2</span> pathogenic or likely pathogenic variants.
                        </blockquote>
                        <blockquote class='blockquote'>
                          The following recommendations are from the guideline version 2.2019 for Prostate Cancer:
                        </blockquote>
                        <blockquote class='blockquote'>
                          Genetic testing for pathogenic variants related to inherited cancer risk should be considered in men with prostate cancer. Results may be helpful for genetic counseling and also for consideration of optimal chemotherapy regimen. Eligibility for clinical trials may also be determined through the results of genetic testing. Click here to learn more about clinical trials.
                        </blockquote>
          </div>
                        </div>

</template>

<script>
  import dynamicBlockquote from '../../components/dynamicPage/BlockQuote'
  import dynamicTable from '../../components/dynamicPage/Table'
  import dynamicTab from '../../components/dynamicPage/Tabs'
  import { mapFields } from 'vuex-map-fields';
  export default {
      components : {
      dynamicBlockquote,
      dynamicTable,
      dynamicTab,
      },
      props : {
          variant:Object
      },
      data(){
          return {
          loader : true,
          testResultContent : null
          }
      },
      mounted() {

      },
        computed: {
      ...mapFields([
        'isAuthorized',
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ])
    },
  }
</script>

<style>

</style>
